import React from "react";
import connectUserAndChat from "../Store/connectUserAndChat";

export default connectUserAndChat(function HelpSpanish() {
  return (
    <div className="help__block" lang="es">
      <i className="help__icon icon-globe" />
      <div className="help__subject">
        <b>Traducci&oacute; n Espa&ntilde;ola</b>
        <p className="help__small">
          <a
            href="https://www.dev.webstaurantstore.com/documents/pdf/how_to_order/como_hacer_una_orden_espanol.pdf"
            className="underline"
          >
            C&oacute;mo ordenar por nuestra p&aacute;gina
          </a>
          <br />
          <a
            href="https://www.dev.webstaurantstore.com/documents/pdf/how_to_order/informacion_importante_acerca_de_su_entrega_espanol.pdf"
            className="underline"
          >
            Informaci&oacute;n importante acerca de su entrega
          </a>
        </p>
      </div>
    </div>
  );
});
